const LoadStatus = ({loadingText}) => {
    return (
        <div className="loadingIndicator">
            {loadingText || "Loading..."}
        </div>
    );
};

export default LoadStatus;
